import { render, staticRenderFns } from "./ManageUsersEdit.vue?vue&type=template&id=98b008c8&"
import script from "./ManageUsersEdit.vue?vue&type=script&lang=ts&"
export * from "./ManageUsersEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports